export const getUname = function (attr: { key: string; organization: string }) {
  if (!attr.key) throw new Error('Unique name not provided');

  if (
    attr.organization === 'jack-health' ||
    attr.organization === 'jill-health'
  ) {
    return attr.key.toLowerCase().trim();
  }

  return (
    attr.key.toLowerCase().trim() + '#' + attr.organization.toLowerCase().trim()
  );
};
